import {
  ListTile,
  ListTileType,
  QuickActionTile,
  TileStatus,
  TileType,
} from '@varo/graphql-schema-types';
import { HomeCardDependencies } from 'features/home/HomeScreen/dependencies/types';
import { ScrollingButtonGroupProps } from 'shared/containers/vxl/groups/ScrollingButtonGroup/ScrollingButtonGroup';
import { VXLGroup, VXLGroupId } from 'shared/renderer/types';
import { isNotNil } from 'shared/utils/isNotNil/isNotNil';

export interface QuickActionGroup extends VXLGroup {
  id: string;
  name: VXLGroupId.SCROLLING_BUTTON_GROUP;
  props: ScrollingButtonGroupProps;
}

const quickActionListTile = (
  tile: ListTile,
  { navigateToRoute }: HomeCardDependencies,
): QuickActionGroup | null => {
  const quickActionTiles = tile.tiles.filter(
    (tile) => tile.tileType === TileType.QuickAction,
  ) as QuickActionTile[];

  if (tile.status !== TileStatus.Loaded || !quickActionTiles.length) {
    return null;
  }

  if (tile.listTileType === ListTileType.QuickActions) {
    return {
      id: tile.id,
      name: VXLGroupId.SCROLLING_BUTTON_GROUP,
      props: {
        buttons: quickActionTiles.map((action) => {
          const handlePress = () => {
            if (isNotNil(action.onPress)) {
              navigateToRoute(action.onPress);
            }
          };

          return {
            id: action.id,
            props: {
              label: action.title,
              onPress: isNotNil(action.onPress) ? handlePress : null,
            },
          };
        }),
      },
    };
  }

  return null;
};

export default quickActionListTile;
